module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/street-park-icon-b04af2b054c55135b656770ee61e9832.png";